import { render, staticRenderFns } from "./ac-switch-button.vue?vue&type=template&id=d88e9336&"
import script from "./ac-switch-button.vue?vue&type=script&lang=js&"
export * from "./ac-switch-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports